// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"661":"c41080fe","787":"fdf519de"}[chunkId] + ".chunk.js";
};